import LayoutWithSpacing from '@Components/layout/layoutWithSpacing'
import { FooterResponse } from '../../apis/footer'
import Image from 'next/image'
import Typography from '@Components/typo'
import { Mail, Smartphone } from 'lucide-react'
import Link from 'next/link'
import LinkButton from '@Components/button/linkButton'
import Line from '../../../public/images/line-icon.svg'
import Facebook from '../../../public/images/facebook.svg'
import Instagram from '../../../public/images/ig.svg'

const Footer = ({ footer }: { footer?: FooterResponse }) => {
  const logoUrl = footer?.Logo?.url || ''
  return (
    <div className='bg-neutral-level-2-default'>
      <LayoutWithSpacing className='pb-16'>
        <div className='relative flex flex-col gap-14 lg:flex-row lg:gap-10'>
          <div className='flex w-4/6 flex-col gap-4 md:w-2/6'>
            <Image src={logoUrl} width={100} height={100} alt='' />
            <Typography size='base' color='text-content-default'>
              {footer?.Address}
            </Typography>
            <div
              className='flex items-center gap-1'
              onClick={() => window.open(`tel:+66${footer?.PhoneNumber}`)}
            >
              <Smartphone />
              <LinkButton
                typoSize='base'
                handleClick={() => window.open(`tel:+66${footer?.PhoneNumber}`)}
              >
                {footer?.PhoneNumber}
              </LinkButton>
            </div>
            <div className='mt-6 flex items-center gap-8 lg:mb-20'>
              {footer?.Facebook && (
                <Link href={footer?.Facebook || '/'} aria-label='facebook'>
                  <Image
                    src={Facebook}
                    alt=''
                    className='h-icon-lg w-icon-lg'
                  />
                </Link>
              )}

              {footer?.Line && (
                <Link href={footer?.Line || '/'} aria-label='line'>
                  <Image src={Line} alt='' className='h-icon-lg w-icon-lg' />
                </Link>
              )}
              {footer?.Instagram && (
                <Link href={footer?.Instagram || '/'} aria-label='instagram'>
                  <Image
                    src={Instagram}
                    alt=''
                    className='h-icon-lg w-icon-lg'
                  />
                </Link>
              )}
            </div>
          </div>
          <div className='grid w-4/6 grid-cols-2 gap-14 md:grid-cols-3 xl:grid-cols-4'>
            <div className='col-span-2 flex flex-col gap-4 md:col-span-1'>
              <Typography weight='bold' size='small'>
                {footer?.ProductAndServicesTitle}
              </Typography>
              {footer?.ProductAndServices.map((item, index) => (
                <Link href={item.Path} key={index}>
                  <Typography size='base' className='cursor-pointer'>
                    {item.Title}
                  </Typography>
                </Link>
              ))}
            </div>
            <div className='flex flex-col gap-4'>
              <Typography weight='bold' size='small'>
                {footer?.InformationTitle}
              </Typography>
              {footer?.InformationSubmenus.map((item, index) => (
                <Link href={item.Path} key={index}>
                  <Typography size='base' className='cursor-pointer'>
                    {item.Title}
                  </Typography>
                </Link>
              ))}
            </div>
            <div className='flex flex-col gap-4'>
              <Typography weight='bold' size='small'>
                {footer?.SupportTitle}
              </Typography>
              {footer?.SupportSubmenus.map((item, index) => (
                <Link href={item.Path} key={index}>
                  <Typography
                    key={index}
                    size='base'
                    className='cursor-pointer'
                  >
                    {item.Title}
                  </Typography>
                </Link>
              ))}
            </div>
            <div className='flex flex-col gap-4'>
              <Typography weight='bold' size='small'>
                {footer?.DownloadAppTitle}
              </Typography>
              {footer?.DownloadAppAndroid && (
                <Link href={footer?.DownloadAppAndroid} target='_blank'>
                  <Image
                    src={footer?.DownloadAndroidImage?.url}
                    width={100}
                    height={100}
                    className='w-[161px] cursor-pointer'
                    alt='android-image'
                  />
                </Link>
              )}
              {footer?.DownloadAppIos && (
                <Link href={footer?.DownloadAppIos} target='_blank'>
                  <Image
                    src={footer?.DownloadIosImage?.url}
                    width={100}
                    height={100}
                    className='w-[161px] cursor-pointer'
                    alt='ios-image'
                  />
                </Link>
              )}
              <Image
                src={footer?.QrCodeDownload?.url || ''}
                width={100}
                height={100}
                alt=''
              />
            </div>
          </div>
          <div className='absolute bottom-2'>© 2023 On-ion</div>
        </div>
      </LayoutWithSpacing>
    </div>
  )
}

export default Footer
